import {
    ProductExDetailAccountType,
    ProductExDetailBeforeOrderListElementType,
    ProductExDetailBeforeOrderListSearchParamType,
    ProductExDetailBeforeOrderListType,
    ProductExDetailDeliveryElementType,
    ProductExDetailInfoType,
    ProductExDetailSearchParamType,
    ProductExDetailShippingElementType,
    ProductExDetailType
} from "../interface";

export const productExDetailSearchParamInit: ProductExDetailSearchParamType = {
    newErpProductid: "",
    pageNo: 1,
    limit: 10
}

export const productExDetailDeliveryElementInit: ProductExDetailDeliveryElementType = {
    addressId: "",
    newTxtPostalcode: "",
    line1: "",
    line2: null,
    name: "",
};

export const productExDetailInfoInit: ProductExDetailInfoType = {
    newErpProductid: "",
    subDescription: "",
    newTxtNmItem: "",
    newTxtStndItem: "",
    productExplain: "",
    createdon: "",
    nameOfCreator: "",
    mainDescription: "",
    vendor: null,
    category: null,
    majorCategory: "",
    subCategory: "",
    newIQty: 0,
    newLProductGroupValue: "",
    newProductGroupid: "",  // 내부수정: 추가
    productRange: ""
};

export const productExDetailShippingElementInit: ProductExDetailShippingElementType = {
    idx: 0,
    codeEntriesId: 0,
    shippingMethod: "",
};

export const productExDetailAccountInit: ProductExDetailAccountType = {
    dailyAverageRate: null,
    initialQuotedRate: null,
    remittanceRate: null,
    paymentMethod: "",
    paymentMethodCode: "",
    paymentDueDate: "",
    shippingType: "",
    shippingCost: "",
};

export const productExDetailInit: ProductExDetailType = {
    deliveryDestinationList: [],
    erpProductImageVO: {},
    productDetail: productExDetailInfoInit,
    shippingMethod: [],
    searchProductWithAccountDetailRes: productExDetailAccountInit

}

export const productExDetailBeforeOrderListSearchParamInit: ProductExDetailBeforeOrderListSearchParamType = {
    newErpProductid: "",
    pageNo: 1,
    limit: 10,
    userId: 0
}

export const productExDetailBeforeOrderListInit: ProductExDetailBeforeOrderListType = {
    list: [],
    totalCount: 0,
};

export const productExDetailBeforeOrderListElementInit: ProductExDetailBeforeOrderListElementType = {
    exchangeRateCondition1Name: "",
    exchangeRateCondition2Name: "",
    exchangeRateCondition3Name: "",
    newIQty: 0,
    newLErpProductValue: "",
    newTxtNmItem: "",
    newTxtStandard: "",
    orderState: "",
    purchaseOrderDt: "",
    purchaseOrderState: 0,
    shipmentName: "",
    newPShipment: 0,
};
